import axios from 'axios';
import { ENDPOINTS } from './_config';

export const getNavigationItems = async () => {
  try {
    const request = await fetch(ENDPOINTS.NAVIGATION);
    const response = await request.json();

    localStorage.setItem('navigation', JSON.stringify(response));
    localStorage.setItem('navigation-time-stamp', Date.now());

    return response;
  } catch (e) {
    return null;
  }
};

export const fetchHeaderMenu = async () => {
  try {
    const response = await axios.get(
      ENDPOINTS.GET_HEADER
    );
    // response.data will contain the JSON data
    console.log("Menu Data:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching header menu:", error);
    return null;
  }
};
